/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Signup } from '../../login/signup';
import { AsideMyinfo } from '../../_layout/aside-myinfo';

export function MyPage(props: RouteComponentProps) {
  useEffect(() => {
    if (window.localStorage.getItem('token') === null) {
      props.history.push('/');
      props.history.push('/login');
    }
  }, []);

  const userInfo = {
    name: window.localStorage.name,
    username: window.localStorage.username,
  };

  return (
    <main className="sub wrapper">
      <AsideMyinfo />
      <Signup userinfo={userInfo} props={props} />
    </main>
  );
}
